<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Forgot Password v1 -->
      <b-overlay :show="show" rounded="sm" no-fade>
        <b-card class="mb-0">
          <b-link class="brand-logo">
            <!-- logo -->
            <img src="_logo.png" alt="Logo" />

            <h2 class="brand-text text-primary ml-1">{{ title }}</h2>
          </b-link>

        

          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group label="Email" label-for="forgot-password-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="forgot-password-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-button type="submit" variant="primary" block> دخول </b-button>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
      <!-- /Forgot Password v1 -->
    </div>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: "",
      // validation
      required,
      email,
    };
  },
  methods: {
    validationForm() {
      const data = `fullName=${encodeURIComponent(
        this.userEmail
      )}&role=VIEWER&meetingID=${
        this.$route.params.id
      }&password=1234567&redirect=true`;
      const checksum = sha1(
        "join" + data + "9jR3Y9VaB5fAQZcsKfJNafIL6ynZMahfLnkIDb6U14c"
      );

      const link = `https://vc3.sunnah.live/bigbluebutton/api/join?${data}&checksum=${checksum}`;
      window.location.href = link;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
